import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToolbarButton, ToolbarConfig } from './interfaces';

@Injectable()
export class ToolbarService {
  private toolbarConfig$$: BehaviorSubject<ToolbarConfig | null> = new BehaviorSubject(null);

  get toolbarConfig$() {
    return this.toolbarConfig$$.asObservable();
  }

  public setConfig(config: ToolbarConfig): void {
    this.toolbarConfig$$.next(config);
  }

  set actions(actions: ToolbarButton[]) {
    this.toolbarConfig$$.next({ ...this.toolbarConfig$$.getValue(), actions });
  }

  public disableButtons(): void {
    const config = this.toolbarConfig$$.getValue();
    const disabledActions = config.actions.map((b) => {
      b.disabled = true;
      return b;
    });
    this.toolbarConfig$$.next({ ...config, actions: disabledActions });
  }
}
